module.exports = __webpack_public_path__ + "static/A4Lieu_gauche_1_sphere.4805fa26.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/A4Lieu_gauche_1_sphere.jpg
// module id = 867
// module chunks = 127938634361352